// Gen 3 Type Effectiveness Chart
// Values: 0 = immune, 0.5 = not very effective, 1 = normal, 2 = super effective

export const typeEffectiveness = {
  Normal: {
    Normal: 1, Fire: 1, Water: 1, Electric: 1, Grass: 1, Ice: 1, Fighting: 1, Poison: 1, Ground: 1, Flying: 1, Psychic: 1, Bug: 1, Rock: 0.5, Ghost: 0, Steel: 0.5, Dark: 1, Dragon: 1
  },
  Fire: {
    Normal: 1, Fire: 0.5, Water: 0.5, Electric: 1, Grass: 2, Ice: 2, Fighting: 1, Poison: 1, Ground: 1, Flying: 1, Psychic: 1, Bug: 2, Rock: 0.5, Ghost: 1, Steel: 2, Dark: 1, Dragon: 0.5
  },
  Water: {
    Normal: 1, Fire: 2, Water: 0.5, Electric: 1, Grass: 0.5, Ice: 1, Fighting: 1, Poison: 1, Ground: 2, Flying: 1, Psychic: 1, Bug: 1, Rock: 2, Ghost: 1, Steel: 1, Dark: 1, Dragon: 0.5
  },
  Electric: {
    Normal: 1, Fire: 1, Water: 2, Electric: 0.5, Grass: 0.5, Ice: 1, Fighting: 1, Poison: 1, Ground: 0, Flying: 2, Psychic: 1, Bug: 1, Rock: 1, Ghost: 1, Steel: 1, Dark: 1, Dragon: 0.5
  },
  Grass: {
    Normal: 1, Fire: 0.5, Water: 2, Electric: 1, Grass: 0.5, Ice: 1, Fighting: 1, Poison: 0.5, Ground: 2, Flying: 0.5, Psychic: 1, Bug: 0.5, Rock: 2, Ghost: 1, Steel: 0.5, Dark: 1, Dragon: 0.5
  },
  Ice: {
    Normal: 1, Fire: 0.5, Water: 0.5, Electric: 1, Grass: 2, Ice: 0.5, Fighting: 1, Poison: 1, Ground: 2, Flying: 2, Psychic: 1, Bug: 1, Rock: 1, Ghost: 1, Steel: 0.5, Dark: 1, Dragon: 2
  },
  Fighting: {
    Normal: 2, Fire: 1, Water: 1, Electric: 1, Grass: 1, Ice: 2, Fighting: 1, Poison: 0.5, Ground: 1, Flying: 0.5, Psychic: 0.5, Bug: 0.5, Rock: 2, Ghost: 0, Steel: 2, Dark: 2, Dragon: 1
  },
  Poison: {
    Normal: 1, Fire: 1, Water: 1, Electric: 1, Grass: 2, Ice: 1, Fighting: 1, Poison: 0.5, Ground: 0.5, Flying: 1, Psychic: 1, Bug: 1, Rock: 0.5, Ghost: 0.5, Steel: 0, Dark: 1, Dragon: 1
  },
  Ground: {
    Normal: 1, Fire: 2, Water: 1, Electric: 2, Grass: 0.5, Ice: 1, Fighting: 1, Poison: 2, Ground: 1, Flying: 0, Psychic: 1, Bug: 0.5, Rock: 2, Ghost: 1, Steel: 2, Dark: 1, Dragon: 1
  },
  Flying: {
    Normal: 1, Fire: 1, Water: 1, Electric: 0.5, Grass: 2, Ice: 1, Fighting: 2, Poison: 1, Ground: 1, Flying: 1, Psychic: 1, Bug: 2, Rock: 0.5, Ghost: 1, Steel: 0.5, Dark: 1, Dragon: 1
  },
  Psychic: {
    Normal: 1, Fire: 1, Water: 1, Electric: 1, Grass: 1, Ice: 1, Fighting: 2, Poison: 2, Ground: 1, Flying: 1, Psychic: 0.5, Bug: 1, Rock: 1, Ghost: 1, Steel: 0.5, Dark: 0, Dragon: 1
  },
  Bug: {
    Normal: 1, Fire: 0.5, Water: 1, Electric: 1, Grass: 2, Ice: 1, Fighting: 0.5, Poison: 0.5, Ground: 1, Flying: 0.5, Psychic: 2, Bug: 1, Rock: 1, Ghost: 0.5, Steel: 0.5, Dark: 2, Dragon: 1
  },
  Rock: {
    Normal: 1, Fire: 2, Water: 1, Electric: 1, Grass: 1, Ice: 2, Fighting: 0.5, Poison: 1, Ground: 0.5, Flying: 2, Psychic: 1, Bug: 2, Rock: 1, Ghost: 1, Steel: 0.5, Dark: 1, Dragon: 1
  },
  Ghost: {
    Normal: 0, Fire: 1, Water: 1, Electric: 1, Grass: 1, Ice: 1, Fighting: 1, Poison: 1, Ground: 1, Flying: 1, Psychic: 2, Bug: 1, Rock: 1, Ghost: 2, Steel: 1, Dark: 0.5, Dragon: 1
  },
  Steel: {
    Normal: 1, Fire: 0.5, Water: 0.5, Electric: 0.5, Grass: 1, Ice: 2, Fighting: 1, Poison: 1, Ground: 1, Flying: 1, Psychic: 1, Bug: 1, Rock: 2, Ghost: 1, Steel: 0.5, Dark: 1, Dragon: 1
  },
  Dark: {
    Normal: 1, Fire: 1, Water: 1, Electric: 1, Grass: 1, Ice: 1, Fighting: 0.5, Poison: 1, Ground: 1, Flying: 1, Psychic: 2, Bug: 1, Rock: 1, Ghost: 2, Steel: 1, Dark: 0.5, Dragon: 1
  },
  Dragon: {
    Normal: 1, Fire: 1, Water: 1, Electric: 1, Grass: 1, Ice: 1, Fighting: 1, Poison: 1, Ground: 1, Flying: 1, Psychic: 1, Bug: 1, Rock: 1, Ghost: 1, Steel: 0.5, Dark: 1, Dragon: 2
  },

};

// Helper function to calculate type effectiveness
export function calculateEffectiveness(attackingTypes, defendingTypes) {
  let totalEffectiveness = 1;
  
  for (const attackingType of attackingTypes) {
    for (const defendingType of defendingTypes) {
      totalEffectiveness *= typeEffectiveness[attackingType][defendingType];
    }
  }
  
  return totalEffectiveness;
}

// Helper function to get types that are super effective against given types
export function getSuperEffectiveTypes(types) {
  const superEffective = [];
  
  for (const type in typeEffectiveness) {
    let effectiveness = 1;
    for (const defendingType of types) {
      effectiveness *= typeEffectiveness[type][defendingType];
    }
    if (effectiveness > 1) {
      superEffective.push(type);
    }
  }
  
  return superEffective;
}

// Helper function to get types that are weak against given types
export function getWeakTypes(types) {
  const weak = [];
  
  for (const type in typeEffectiveness) {
    let effectiveness = 1;
    for (const attackingType of types) {
      effectiveness *= typeEffectiveness[attackingType][type];
    }
    if (effectiveness > 1) {
      weak.push(type);
    }
  }
  
  return weak;
}
